
export enum CellType {
    Group,
    Identifier,
    Tag,
    String
}
